import { CompetitionsResponse } from "../management-subscription/types";

export const MOCK_USER_SUBSCRIPTION: SubscriptionPlanUser = {
  cancel_at_period_end: false,
  current_period_start: 1757924702,
  current_period_end: 1760516702,
  status: "active",
  id: "price_1Rl8ggPHLlhKNpAHO7XHQivz",
  productId: "prod_SgViLLTfDzY0u0",
  name: "Essential",
  description:
    "Includes 28 entries in 21 competitions monthly. Covers prize draws worth approximately £2.7M including house, cars, and more.",
  amount: 999,
  currency: "gbp",
  interval: "month",
  intervalCount: 1,
  metadata: [
    ["DC", "1"],
    ["HC", "2"],
    ["IW", "2"],
    ["LS", "2"],
    ["XC", "2"],
    ["card_gradient_from", "#224790"],
    ["card_gradient_to", "#6D18CE"],
    ["gross_monthly_spend", "999"],
    [
      "how_it_works",
      "Dream Home and Luxury Cars entries are automatic. Dream Car, Instant Win & Lifestyle tickets need to be entered manually.",
    ],
    [
      "main_description",
      "Your subscription includes **28 entries** in **21 competitions** monthly. Covers prize draws worth approximately **£2.7M** including house, cars, and more.",
    ],
    ["tag_color", "NULL"],
    ["tag_icon", "NULL"],
    ["tag_text", "NULL"],
    ["total_entries", "28"],
  ],
  features: [
    "2 tickets, to win a Dream Home",
    "12 tickets, to win 6 Luxury Cars",
    "8 tickets, to the Lifestyle Competition",
    "2 tickets, to any Instant Win Competition",
    "4 tickets, to the Dream Car Competition (£0.90/ticket)",
  ],
  prices: [
    {
      id: "price_1Rl8ggPHLlhKNpAHO7XHQivz",
      object: "price",
      active: true,
      billing_scheme: "per_unit",
      created: 1752585266,
      currency: "gbp",
      custom_unit_amount: null,
      livemode: false,
      lookup_key: null,
      metadata: {
        base_price: "£19.60",
        discount_value_card: "49%",
        upsell_discount_value_switch: "£12",
      },
      nickname: null,
      product: {
        id: "prod_SgViLLTfDzY0u0",
        object: "product",
        active: true,
        attributes: [],
        created: 1752585265,
        default_price: "price_1Rl8ggPHLlhKNpAHO7XHQivz",
        description:
          "Includes 28 entries in 21 competitions monthly. Covers prize draws worth approximately £2.7M including house, cars, and more.",
        images: [],
        livemode: false,
        marketing_features: [
          {
            name: "2 tickets, to win a Dream Home",
          },
          {
            name: "12 tickets, to win 6 Luxury Cars",
          },
          {
            name: "8 tickets, to the Lifestyle Competition",
          },
          {
            name: "2 tickets, to any Instant Win Competition",
          },
          {
            name: "4 tickets, to the Dream Car Competition (£0.90/ticket)",
          },
        ],
        metadata: {
          DC: "1",
          HC: "2",
          IW: "2",
          LS: "2",
          XC: "2",
          card_gradient_from: "#224790",
          card_gradient_to: "#6D18CE",
          gross_monthly_spend: "999",
          how_it_works:
            "Dream Home and Luxury Cars entries are automatic. Dream Car, Instant Win & Lifestyle tickets need to be entered manually.",
          main_description:
            "Your subscription includes **28 entries** in **21 competitions** monthly. Covers prize draws worth approximately **£2.7M** including house, cars, and more.",
          tag_color: "NULL",
          tag_icon: "NULL",
          tag_text: "NULL",
          total_entries: "28",
          tag_icon_url: "",
        },
        name: "Essential",
        package_dimensions: null,
        shippable: null,
        statement_descriptor: null,
        tax_code: null,
        type: "service",
        unit_label: null,
        updated: 1754313701,
        url: null,
      },
      recurring: {
        interval: "month",
        interval_count: 1,
        meter: null,
        trial_period_days: null,
        usage_type: "licensed",
      },
      tax_behavior: "unspecified",
      tiers_mode: null,
      transform_quantity: null,
      type: "recurring",
      unit_amount: 999,
      unit_amount_decimal: "999",
    },
  ],
};

export const MOCK_DATA_BOTB_PASS_COMPETITIONS: CompetitionsResponse = {
  played: [
    {
      EndDate: "Sunday",
      HasInstantWin: false,
      TicketText: "STARTING FROM",
      IsRewardCompetition: false,
      CtaTicketValue: "",
      UseDailyPopupForCompetitionId: -1,
      SupportsMultibuy: false,
      MultiBuyLowerPercent: 0,
      MultiBuyLowerQuantity: 0,
      MultiBuyUpperPercent: 0,
      MultiBuyUpperQuantity: 0,
      IsMobileAppOnly: false,
      Title: "Dream Car",
      ImageUrl: "https://cdn.botb.com/media/qs1doq24/botb-7661-competition-card-342x212.webp",
      ImageDoubleUrl: "https://cdn.botb.com/media/p3xevkbi/botb-7661-competition-card-659x201-x-2.webp",
      PageUrl: "/prizes/cars",
      AdditionalCashText: "+ £50,000",
      CompetitionId: 5133,
      CompetitionPictureTypeId: 1,
      NavigationColour: "navigation-orange",
      IsSinglePrizeMode: false,
      CtaText: "This week only, win two cars with one ticket!",
      CtaTextValidated: "This week only, win two cars with one ticket!",
      CurrencySymbol: "£",
      FormattedPrice: "£0.90",
      FormattedPriceWithoutCurrency: "0.90",
      FormattedOriginalPrice: "£0.90",
      PercentOffValue: 0,
      OverrideDiscountValue: null,
      CtaAddToBasketPrizeId: 12675,
      PostalEntryText: "",
    },
  ],
  lost: [
    {
      EndDate: "Tomorrow",
      HasInstantWin: false,
      TicketText: "TICKET PRICE",
      IsRewardCompetition: false,
      CtaTicketValue: "",
      UseDailyPopupForCompetitionId: 5129,
      SupportsMultibuy: false,
      MultiBuyLowerPercent: 0,
      MultiBuyLowerQuantity: 0,
      MultiBuyUpperPercent: 0,
      MultiBuyUpperQuantity: 0,
      IsMobileAppOnly: false,
      Title: "Range Rover For 22p",
      ImageUrl: "https://cdn.botb.com/media/w4vdtrkv/botb-7637-competition-card-342x212.webp",
      ImageDoubleUrl: "https://cdn.botb.com/media/w4vdtrkv/botb-7637-competition-card-342x212.webp",
      PageUrl: "/prizes/winbig",
      AdditionalCashText: null,
      CompetitionId: 5129,
      CompetitionPictureTypeId: 203,
      NavigationColour: "navigation-red",
      IsSinglePrizeMode: true,
      CtaText: "Undeniable British Excellence – Win a Range Rover!",
      CtaTextValidated: "Undeniable British Excellence – Win a Range Rover!",
      CurrencySymbol: "£",
      FormattedPrice: "£0.22",
      FormattedPriceWithoutCurrency: "0.22",
      FormattedOriginalPrice: "£0.22",
      PercentOffValue: 0,
      OverrideDiscountValue: null,
      CtaAddToBasketPrizeId: 115702,
      PostalEntryText:
        '\u003Ch4\u003EPostal Entry for Competitions\u003C/h4\u003E\n\u003Cp style="text-align: justify;"\u003EBOTB offers an alternative method of participating in competitions through Postal Entry, which is detailed below. This method does not require payment beyond the cost of postage.\u003C/p\u003E\n\u003Ch4\u003EConditions for Postal Entry\u003C/h4\u003E\n\u003Cp style="text-align: justify;"\u003EBy using the Postal Entry route, you confirm that you have the legal capacity to participate. You also agree to adhere to our Terms and Conditions and any additional requirements outlined in related promotional materials.\u003C/p\u003E\n\u003Ch4\u003EHow to Enter\u003C/h4\u003E\n\u003Cp style="text-align: justify;"\u003ETo enter a competition by Postal Entry, send a handwritten postcard or letter with the following information:\u003C/p\u003E\n\u003Cul\u003E\n\u003Cli\u003E1. Full name\u003C/li\u003E\n\u003Cli\u003E2. Address, including city and postcode\u003C/li\u003E\n\u003Cli\u003E3. Telephone number\u003C/li\u003E\n\u003Cli\u003E4. Registered email address for your BOTB Account\u003C/li\u003E\n\u003Cli\u003E5. Name of the Competition you wish to enter\u003C/li\u003E\n\u003C/ul\u003E\n\u003Cp\u003E \u003C/p\u003E\n\u003Cp style="text-align: justify;"\u003EEnsure that your handwriting is clear. Mechanically reproduced entries are not permitted. Entries must be sent by post to the following address: 2 Plato Place, 72-74 St Dionis Road, London, SW6 4TU, United Kingdom, with appropriate postage paid.\u003C/p\u003E\n\u003Ch4\u003EEntry Requirements\u003C/h4\u003E\n\u003Cp style="text-align: justify;"\u003EEntries must be sent during the Promotion Period of the competition. Entries received within 2 working days of the competition closing will be included in the draw. Entries postmarked outside the Promotion Period will not be considered valid.\u003C/p\u003E\n\u003Cp style="text-align: justify;"\u003EOnly one entry is allowed per postcard or envelope. Bulk entries sent in the same envelope will not be accepted. However, you may send as many separate Postal Entries as you wish, up to a maximum of 600 entries per person per competition.\u003C/p\u003E\n\u003Ch4\u003EConfirmation of Entry\u003C/h4\u003E\n\u003Cp style="text-align: justify;"\u003EYou will not be officially entered into the Competition until we confirm your Entry via email or through your registered BOTB Account.\u003C/p\u003E\n\u003Ch4\u003EValidity of Entries\u003C/h4\u003E\n\u003Cp style="text-align: justify;"\u003EEntries that do not comply with these guidelines will be considered void. A valid Postal Entry will be included in the prize draw alongside paid-for Online Tickets, with each Postal Entry having an equal chance of winning.\u003C/p\u003E\n\u003Cp style="text-align: justify;"\u003EIt is essential to have an active account on our website when Postal Entries are processed, and all details provided must match those on your user account.\u003C/p\u003E',
    },
  ],
};

export const MOCK_DATA_INVOICES: InvoiceList = {
  object: "list",
  data: [
    {
      id: "in_1SAT0yPHLlhKNpAH5tmp05SC",
      object: "invoice",
      account_country: "GB",
      account_name: "UAT Sandbox",
      account_tax_ids: null,
      amount_due: 999,
      amount_overpaid: 0,
      amount_paid: 0,
      amount_remaining: 999,
      amount_shipping: 0,
      application: null,
      attempt_count: 1,
      attempted: true,
      auto_advance: true,
      automatic_tax: {
        disabled_reason: null,
        enabled: false,
        liability: null,
        provider: null,
        status: null,
      },
      automatically_finalizes_at: null,
      billing_reason: "subscription_cycle",
      collection_method: "charge_automatically",
      created: 1761213256,
      currency: "gbp",
      custom_fields: null,
      customer: "cus_T6gHtwy8qfKAqy",
      customer_address: null,
      customer_email: "recad93053@cnguopin.com",
      customer_name: null,
      customer_phone: null,
      customer_shipping: null,
      customer_tax_exempt: "none",
      customer_tax_ids: [],
      default_payment_method: null,
      default_source: null,
      default_tax_rates: [],
      description: null,
      discounts: [],
      due_date: null,
      effective_at: 1761213593,
      ending_balance: 0,
      footer: null,
      from_invoice: null,
      hosted_invoice_url:
        "https://invoice.stripe.com/i/acct_1RjmMLPHLlhKNpAH/test_YWNjdF8xUmptTUxQSExsaEtOcEFILF9UNmdOMmpVZ2FtOEtFZUQ3Tms3dXIxcmJhdk00U1YxLDE0OTMzNDU3MA0200o7Vn8rYQ?s=ap",
      invoice_pdf:
        "https://pay.stripe.com/invoice/acct_1RjmMLPHLlhKNpAH/test_YWNjdF8xUmptTUxQSExsaEtOcEFILF9UNmdOMmpVZ2FtOEtFZUQ3Tms3dXIxcmJhdk00U1YxLDE0OTMzNDU3MA0200o7Vn8rYQ/pdf?s=ap",
      issuer: {
        type: "self",
      },
      last_finalization_error: null,
      latest_revision: null,
      lines: {
        object: "list",
        data: [
          {
            id: "il_1SLLDoPHLlhKNpAHZ5ol8zNa",
            object: "line_item",
            amount: 999,
            currency: "gbp",
            description: "1 × Essential (at £9.99 / month)",
            discount_amounts: [],
            discountable: true,
            discounts: [],
            invoice: "in_1SAT0yPHLlhKNpAH5tmp05SC",
            livemode: false,
            metadata: {
              email: "recad93053@cnguopin.com",
              optimize_token: "p4RdCg2mzWgNAAwOAgmSChmXX9px-VLMJmioMEt_P8ie445_Obb854d",
              session_token: "p4RdCg2mzWgNAAwOAgmSChmXX9px-VLMJmioMEt_P8ie445_Obb854d",
              userId: "54f8e828-3d77-48ab-9142-bbe3a85e6ac8",
              utm_medium: "menu_entry",
              workflowId: "pay-success-flow-evt_625631000814157825-cust_625630944241388545",
            },
            parent: {
              invoice_item_details: null,
              subscription_item_details: {
                invoice_item: null,
                proration: false,
                proration_details: {
                  credited_items: null,
                },
                subscription: "sub_1SASvMPHLlhKNpAHGogTg1I9",
                subscription_item: "si_T6gH2neq4wKnzB",
              },
              type: "subscription_item_details",
            },
            period: {
              end: 1763891656,
              start: 1761213256,
            },
            pretax_credit_amounts: [],
            pricing: {
              price_details: {
                price: "price_1Rl8ggPHLlhKNpAHO7XHQivz",
                product: "prod_SgViLLTfDzY0u0",
              },
              type: "price_details",
              unit_amount_decimal: "999",
            },
            quantity: 1,
            taxes: [],
          },
        ],
        has_more: false,
        total_count: 1,
        url: "/v1/invoices/in_1SAT0yPHLlhKNpAH5tmp05SC/lines",
      },
      livemode: false,
      metadata: {},
      next_payment_attempt: 1761449287,
      number: "549T3K0S-0002",
      on_behalf_of: null,
      parent: {
        quote_details: null,
        subscription_details: {
          metadata: {
            email: "recad93053@cnguopin.com",
            optimize_token: "p4RdCg2mzWgNAAwOAgmSChmXX9px-VLMJmioMEt_P8ie445_Obb854d",
            session_token: "p4RdCg2mzWgNAAwOAgmSChmXX9px-VLMJmioMEt_P8ie445_Obb854d",
            userId: "54f8e828-3d77-48ab-9142-bbe3a85e6ac8",
            utm_medium: "menu_entry",
            workflowId: "pay-success-flow-evt_625631000814157825-cust_625630944241388545",
          },
          subscription: "sub_1SASvMPHLlhKNpAHGogTg1I9",
        },
        type: "subscription_details",
      },
      payment_settings: {
        default_mandate: null,
        payment_method_options: null,
        payment_method_types: null,
      },
      period_end: 1761213256,
      period_start: 1758621256,
      post_payment_credit_notes_amount: 0,
      pre_payment_credit_notes_amount: 0,
      receipt_number: null,
      rendering: {
        amount_tax_display: "exclude_tax",
        pdf: null,
        template: null,
        template_version: null,
      },
      shipping_cost: null,
      shipping_details: null,
      starting_balance: 0,
      statement_descriptor: null,
      status: "open",
      status_transitions: {
        finalized_at: 1761213593,
        marked_uncollectible_at: null,
        paid_at: null,
        voided_at: null,
      },
      subtotal: 999,
      subtotal_excluding_tax: 999,
      test_clock: "clock_1SAT0uPHLlhKNpAHkbObsG9v",
      total: 999,
      total_discount_amounts: [],
      total_excluding_tax: 999,
      total_pretax_credit_amounts: [],
      total_taxes: [],
      webhooks_delivered_at: 1761213256,
    },
    {
      id: "in_1SASvMPHLlhKNpAHcPco5B2P",
      object: "invoice",
      account_country: "GB",
      account_name: "UAT Sandbox",
      account_tax_ids: null,
      amount_due: 999,
      amount_overpaid: 0,
      amount_paid: 999,
      amount_remaining: 0,
      amount_shipping: 0,
      application: null,
      attempt_count: 0,
      attempted: false,
      auto_advance: false,
      automatic_tax: {
        disabled_reason: null,
        enabled: false,
        liability: null,
        provider: null,
        status: null,
      },
      automatically_finalizes_at: null,
      billing_reason: "subscription_create",
      collection_method: "charge_automatically",
      created: 1758621256,
      currency: "gbp",
      custom_fields: null,
      customer: "cus_T6gHtwy8qfKAqy",
      customer_address: null,
      customer_email: "recad93053@cnguopin.com",
      customer_name: null,
      customer_phone: null,
      customer_shipping: null,
      customer_tax_exempt: "none",
      customer_tax_ids: [],
      default_payment_method: null,
      default_source: null,
      default_tax_rates: [],
      description: null,
      discounts: [],
      due_date: null,
      effective_at: 1758621256,
      ending_balance: 0,
      footer: null,
      from_invoice: null,
      hosted_invoice_url:
        "https://invoice.stripe.com/i/acct_1RjmMLPHLlhKNpAH/test_YWNjdF8xUmptTUxQSExsaEtOcEFILF9UNmdIc2JuUGZNUHJta1RvZzBqVWV5OXhUWHFYSDNQLDE0OTMzNDU3MA0200X54jkNnO?s=ap",
      invoice_pdf:
        "https://pay.stripe.com/invoice/acct_1RjmMLPHLlhKNpAH/test_YWNjdF8xUmptTUxQSExsaEtOcEFILF9UNmdIc2JuUGZNUHJta1RvZzBqVWV5OXhUWHFYSDNQLDE0OTMzNDU3MA0200X54jkNnO/pdf?s=ap",
      issuer: {
        type: "self",
      },
      last_finalization_error: null,
      latest_revision: null,
      lines: {
        object: "list",
        data: [
          {
            id: "il_1SASvMPHLlhKNpAHChYZpKFp",
            object: "line_item",
            amount: 999,
            currency: "gbp",
            description: "1 × Essential (at £9.99 / month)",
            discount_amounts: [],
            discountable: true,
            discounts: [],
            invoice: "in_1SASvMPHLlhKNpAHcPco5B2P",
            livemode: false,
            metadata: {
              email: "recad93053@cnguopin.com",
              optimize_token: "p4RdCg2mzWgNAAwOAgmSChmXX9px-VLMJmioMEt_P8ie445_Obb854d",
              session_token: "p4RdCg2mzWgNAAwOAgmSChmXX9px-VLMJmioMEt_P8ie445_Obb854d",
              userId: "54f8e828-3d77-48ab-9142-bbe3a85e6ac8",
              utm_medium: "menu_entry",
              workflowId: "pay-success-flow-evt_625631000814157825-cust_625630944241388545",
            },
            parent: {
              invoice_item_details: null,
              subscription_item_details: {
                invoice_item: null,
                proration: false,
                proration_details: {
                  credited_items: null,
                },
                subscription: "sub_1SASvMPHLlhKNpAHGogTg1I9",
                subscription_item: "si_T6gH2neq4wKnzB",
              },
              type: "subscription_item_details",
            },
            period: {
              end: 1761213256,
              start: 1758621256,
            },
            pretax_credit_amounts: [],
            pricing: {
              price_details: {
                price: "price_1Rl8ggPHLlhKNpAHO7XHQivz",
                product: "prod_SgViLLTfDzY0u0",
              },
              type: "price_details",
              unit_amount_decimal: "999",
            },
            quantity: 1,
            taxes: [],
          },
        ],
        has_more: false,
        total_count: 1,
        url: "/v1/invoices/in_1SASvMPHLlhKNpAHcPco5B2P/lines",
      },
      livemode: false,
      metadata: {},
      next_payment_attempt: null,
      number: "549T3K0S-0001",
      on_behalf_of: null,
      parent: {
        quote_details: null,
        subscription_details: {
          metadata: {
            email: "recad93053@cnguopin.com",
            optimize_token: "p4RdCg2mzWgNAAwOAgmSChmXX9px-VLMJmioMEt_P8ie445_Obb854d",
            session_token: "p4RdCg2mzWgNAAwOAgmSChmXX9px-VLMJmioMEt_P8ie445_Obb854d",
            userId: "54f8e828-3d77-48ab-9142-bbe3a85e6ac8",
            utm_medium: "menu_entry",
            workflowId: "pay-success-flow-evt_625631000814157825-cust_625630944241388545",
          },
          subscription: "sub_1SASvMPHLlhKNpAHGogTg1I9",
        },
        type: "subscription_details",
      },
      payment_settings: {
        default_mandate: null,
        payment_method_options: null,
        payment_method_types: null,
      },
      period_end: 1758621256,
      period_start: 1758621256,
      post_payment_credit_notes_amount: 0,
      pre_payment_credit_notes_amount: 0,
      receipt_number: null,
      rendering: {
        amount_tax_display: "exclude_tax",
        pdf: null,
        template: null,
        template_version: null,
      },
      shipping_cost: null,
      shipping_details: null,
      starting_balance: 0,
      statement_descriptor: null,
      status: "paid",
      status_transitions: {
        finalized_at: 1758621256,
        marked_uncollectible_at: null,
        paid_at: 1758621261,
        voided_at: null,
      },
      subtotal: 999,
      subtotal_excluding_tax: 999,
      test_clock: null,
      total: 999,
      total_discount_amounts: [],
      total_excluding_tax: 999,
      total_pretax_credit_amounts: [],
      total_taxes: [],
      webhooks_delivered_at: 1758621256,
    },
  ],
  has_more: false,
  url: "/v1/invoices",
};
